<div class="card">
  <div class="card-header pb-0">
    <div class="media-space-between">
      <h4>{{ "admin.locations.franchise.title" | translate }}</h4>
      <div class="media-body">
        <form class="media-space-between" [formGroup]="formFilter">
          <div class="faq-form m-r-10" style="color: darkgrey; display: flex">
            <i class="search-icon" data-feather="search"></i>
            <div>
              <div class="input-group">
                <app-search-field
                  class="m-r-10"
                  [form]="formFilter | asFormGroup"
                  [filterOptions]="filter"
                  inputFormControlName="companyName"
                  [placeholder]="'placeholder.searchByCompanyName' | translate"
                  (emitSelectedOptions)="saveOptionFilter($event)"
                ></app-search-field>
              </div>
            </div>
          </div>
          <div class="m-r-10">
            <button
              class="btn btn-primary"
              type="button"
              style="width: max-content"
              data-bs-toggle="modal"
              data-original-title="test"
              (click)="onClickShowModal()"
              [disabled]="!isAuthorised"
            >
              {{ "buttons.addLocations" | translate }}
            </button>
          </div>
          <div>
            <a
            class="btn btn-outline-primary project-box"
            [ngbTooltip]="'export.title' | translate"
            (click)="exportCSV(exportFile)"
          >
            <i class="icon-import"></i>
          </a>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="table-responsive data-table table-scrollable" style="--max-h: 70vh;">
      <table class="table table-border-vertical custom-scrollbar">
          <thead style="z-index: 7;">
            <tr>
              <th 
                style="position: sticky; left: 0; z-index: 1;
                      border-right-color: #D9D9D9;
                      box-shadow: 3px 0px 6.6px 0px rgba(0,0,0,0.1);
                    "
              >
                {{ "admin.locations.franchise.franchise" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.franchised" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.region" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.zone" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.categories" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.subcategories" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.tags" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.option" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.pilotPhaseEnd" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.responsible" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.email" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.phone" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.price" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.paymentFrequency" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.status" | translate }}
              </th>
              <th>
                {{ "admin.locations.franchise.actions" | translate }}
              </th>
              
            </tr>
          </thead>
          <ng-container *ngFor="
              let franchise of franchiseResult?.franchises;
              let i = index
            " >
            <tbody>
                <tr [ngStyle]="(i % 2) ? {'--bs-table-accent-bg': '#ffffff'} : {'--bs-table-accent-bg': '#f3f3f3'}">
                  <td [attr.rowspan]="franchise.locations.length"
                    style="
                      position: sticky; left: 0; border-right-color: #D9D9D9; 
                      box-shadow: 3px 0px 6.6px 0px rgba(0,0,0,0.1);
                      z-index: 1;
                    "
                    [ngStyle]="(i % 2) ? {'background': '#ffffff', 'z-index': pageSize-i+1} : {'background': '#f3f3f3', 'z-index': pageSize-i+1}"
                  >
                    <div
                      style=" display: flex; flex-direction: row-reverse; "
                      [ngbTooltip]="
                        franchise.franchise.archivedDate ? tooltipArchivedDate : null
                      "
                      placement="top"
                    >
                      <app-drop-zone-options
                        [options]="getOptions(franchiseOptions, franchise.franchise.archivedDate)"
                        (optionSelected)="saveFranchiseOption($event, franchise.franchise)"
                        [isGroupButton]="true"
                      ></app-drop-zone-options>
                      <span style="white-space: nowrap;">
                        <a
                          type="button"
                          [routerLink]="['../../location-partners/franchise/statistics/']"
                          [ngStyle]="{ 
                            color: franchise.franchise.archivedDate ? 'red' : 'black',
                            fontWeight: franchise.franchise.archivedDate ? 'bold' : 'normal'
                          }"
                          [queryParams]="{
                            companyName: franchise.franchise.companyName
                          }"
                        >
                          {{ franchise.franchise.companyName}}
                        </a>
                      </span>
                      <ng-template #tooltipArchivedDate>
                        <div style="font-size: 12px;">
                          {{"user.archivedOn" | translate}}
                          {{ franchise.franchise.archivedDate | localizedDate : "short" }}
                        </div>
                      </ng-template>
                    </div>
                  </td>
                  <ng-container *ngIf="franchise.locations.length; else emptyFranchise">
                    <td *ngIf="franchise.locations[0].companyName; else generalNone">
                      <a
                        type="button"
                        [routerLink]="['../../location-partners/repository/statistics/']"
                        style="color: black"
                        [queryParams]="{
                          companyName: franchise.locations[0].companyName
                        }"
                      >
                        {{ franchise.locations[0].companyName }}
                      </a>
                    </td>
                    <td *ngIf="franchise.locations[0].region; else generalNone">
                      {{ franchise.locations[0].region }}
                    </td>
                    <td *ngIf="franchise.locations[0].zoneName; else generalNone">
                      {{ franchise.locations[0].zoneName }}
                    </td>
                    <td *ngIf="franchise.locations[0].category; else generalNone">
                      {{ franchise.locations[0].category }}
                    </td>
                    <td *ngIf="franchise.locations[0].subCategories?.length; else generalNone">
                      {{ franchise.locations[0].subCategories.join(', ') }}
                    </td>
                    <td *ngIf="franchise.locations[0].tags?.length; else generalNone">
                      {{ franchise.locations[0].tags.join(', ') }}
                    </td>
                    <td *ngIf="franchise.locations[0].partnerStatus; else generalNone">
                      <span
                        *ngIf="franchise.locations[0].partnerStatus != null; else none"
                        [ngClass]="
                          'badge ' +
                          badgeService.getBadgeByLocationPartnerStatus(
                            franchise.locations[0].partnerStatus
                          )
                        "
                      >
                        {{
                          "enumMapping.partnerStatus." + franchise.locations[0].partnerStatus
                            | translate
                        }}
                      </span>
                      <ng-template #none>
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeByLocationPartnerPaymentFrequency(
                              paymentFrequencyToShow.NONE
                            )
                          "
                        >
                          {{ "undefined" | translate }}
                        </span>
                      </ng-template>
                    </td>
                    <td *ngIf="franchise.locations[0].pilotPhaseEndDate; else generalNone">
                      {{ franchise.locations[0].pilotPhaseEndDate | localizedDate }}
                    </td>
                    <td *ngIf="franchise.locations[0].firstName || franchise.locations[0].lastName; else generalNone">
                      {{ franchise.locations[0].firstName + " " + franchise.locations[0].lastName }}
                    </td>
                    <td *ngIf="franchise.locations[0].email; else generalNone">
                      {{ franchise.locations[0].email }}
                    </td>
                    <td *ngIf="franchise.locations[0].phone; else generalNone">
                      {{ franchise.locations[0].phone }}
                    </td>
                    <td *ngIf="franchise.locations[0].price || franchise.locations[0].price === 0; else generalNone">
                      {{ franchise.locations[0].price }}
                    </td>
                    <td>
                      <p *ngIf="franchise.locations[0].paymentFrequency; else paymentNone">
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeByLocationPartnerPaymentFrequency(
                              franchise.locations[0].paymentFrequency
                            )
                          "
                        >
                          {{
                            "enumMapping.paymentFrequency." + franchise.locations[0].paymentFrequency
                              | translate
                          }}
                        </span>
                      </p>
                      <ng-template #paymentNone>
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeByLocationPartnerPaymentFrequency(
                              paymentFrequencyToShow.NONE
                            )
                          "
                        >
                          {{ "undefined" | translate }}
                        </span>
                      </ng-template>
                    </td>
                    <td *ngIf="!franchise.locations[0].archivedDate">
                      <div>
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeByLocationPartnerActiveStatus(
                              getActiveStaus(franchise.locations[0])
                            )
                          "
                        >
                          {{
                            "enumMapping.franchiseStatus." + getActiveStaus(franchise.locations[0])
                              | translate
                          }}
                        </span>
                      </div>
                    </td>
                    <td *ngIf="franchise.locations[0].archivedDate">
                      <span
                        [ngbTooltip]="
                          franchise.locations[0].archivedDate ? tooltipArchivedDate : null
                        "
                        placement="bottom"
                        [container]="'body'"
                        [ngClass]="
                          'badge ' +
                          badgeService.getBadgeForUserStatus(
                            isCollaboratorArchived(franchise.locations[0].archivedDate)
                          )
                        "
                      >
                        {{
                          userStatusEnumMapping[
                            isCollaboratorArchived(franchise.locations[0].archivedDate)
                          ] | translate
                        }}
                      </span>

                      <ng-template #tooltipArchivedDate>
                        <div>
                          {{ franchise.locations[0].archivedDate | localizedDate : "short" }}
                        </div>
                      </ng-template>
                    </td>
                    <td>
                      <app-drop-zone-options
                        [options]="getOptions(locationOptions, franchise.locations[0].archivedDate)"
                        (optionSelected)="saveLocationOption($event, franchise.locations[0])"
                      ></app-drop-zone-options>
                    </td>
                    <ng-template #generalNone>
                      <td>
                        {{ "undefined" | translate }}
                      </td>
                    </ng-template>
                  </ng-container>
                  <ng-template #emptyFranchise>
                      <td colspan="16"></td>
                  </ng-template>
                </tr>
                <ng-container
                  *ngFor="let location of franchise.locations.slice(1); let j = index"
                >
                  <tr [ngStyle]="(i % 2) ? {'--bs-table-accent-bg': '#ffffff'} : {'--bs-table-accent-bg': '#f3f3f3'}">
                    <td *ngIf="location.companyName; else generalNone">
                      <a
                        type="button"
                        [routerLink]="['../../location-partners/repository/statistics/']"
                        style="color: black"
                        [queryParams]="{
                          companyName: location.companyName
                        }"
                      >
                        {{ location.companyName }}
                      </a>
                    </td>
                    <td *ngIf="location.region; else generalNone">
                      {{ location.region }}
                    </td>
                    <td *ngIf="location.zoneName; else generalNone">
                      {{ location.zoneName }}
                    </td>
                    <td *ngIf="location.category; else generalNone">
                      {{ location.category }}
                    </td>
                    <td *ngIf="location.subCategories?.length; else generalNone">
                      {{ location.subCategories.join(', ') }}
                    </td>
                    <td *ngIf="location.tags?.length; else generalNone">
                      {{ location.tags.join(', ') }}
                    </td>
                    <td>
                      <span
                        *ngIf="location.partnerStatus != null; else none"
                        [ngClass]="
                          'badge ' +
                          badgeService.getBadgeByLocationPartnerStatus(
                            location.partnerStatus
                          )
                        "
                      >
                        {{
                          "enumMapping.partnerStatus." + location.partnerStatus
                            | translate
                        }}
                      </span>
                      <ng-template #paymentNone>
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeByLocationPartnerPaymentFrequency(
                              paymentFrequencyToShow.NONE
                            )
                          "
                        >
                          {{ "undefined" | translate }}
                        </span>
                      </ng-template>
                    </td>
                    <td *ngIf="location.pilotPhaseEndDate; else generalNone">
                      {{ location.pilotPhaseEndDate | localizedDate  }}
                    </td>
                    <td  *ngIf="location.firstName || location.lastName; else generalNone">
                      {{ location.firstName + " " + location.lastName }}
                    </td>
                    <td *ngIf="location.email; else generalNone">
                      {{ location.email }}
                    </td>
                    <td *ngIf="location.phone; else generalNone">
                      {{ location.phone }}
                    </td>
                    <ng-template #none>
                      <span
                        [ngClass]="
                          'badge ' +
                          badgeService.getBadgeByLocationPartnerPricingMethod(
                            pricingMethod.NONE
                          )
                        "
                      >
                        {{ "undefined" | translate }}
                      </span>
                    </ng-template>
                    <td *ngIf="location.price || location.price === 0 ; else generalNone">
                      {{ location.price }}
                    </td>
                    <td>
                      <p *ngIf="location.paymentFrequency; else paymentNone">
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeByLocationPartnerPaymentFrequency(
                              location.paymentFrequency
                            )
                          "
                        >
                          {{
                            "enumMapping.paymentFrequency." + location.paymentFrequency
                              | translate
                          }}
                        </span>
                      </p>
                      <ng-template #paymentNone>
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeByLocationPartnerPaymentFrequency(
                              paymentFrequencyToShow.NONE
                            )
                          "
                        >
                          {{ "undefined" | translate }}
                        </span>
                      </ng-template>
                    </td>
                    <td *ngIf="!location.archivedDate">
                      <div>
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeByLocationPartnerActiveStatus(
                              getActiveStaus(location)
                            )
                          "
                        >
                          {{
                            "enumMapping.franchiseStatus." + getActiveStaus(location)
                              | translate
                          }}
                        </span>
                      </div>
                    </td>
                    <td *ngIf="location.archivedDate">
                      <span
                        [ngbTooltip]="
                          location.archivedDate ? tooltipArchivedDate : null
                        "
                        placement="bottom"
                        [container]="'body'"
                        [ngClass]="
                          'badge ' +
                          badgeService.getBadgeForUserStatus(
                            isCollaboratorArchived(location.archivedDate)
                          )
                        "
                      >
                        {{
                          userStatusEnumMapping[
                            isCollaboratorArchived(location.archivedDate)
                          ] | translate
                        }}
                      </span>

                      <ng-template #tooltipArchivedDate>
                        <div>
                          {{ location.archivedDate | localizedDate : "short" }}
                        </div>
                      </ng-template>
                    </td>
                    <td>
                      <app-drop-zone-options
                        [options]="getOptions(locationOptions, location.archivedDate)"
                        (optionSelected)="saveLocationOption($event, location)"
                      ></app-drop-zone-options>
                    </td>
                    <ng-template #generalNone>
                      <td>
                        {{ "undefined" | translate }}
                      </td>
                    </ng-template>
                  </tr>
                </ng-container>
            </tbody>
          </ng-container>
        </table>
        <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
          {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
        </div>  
        <div
          *ngIf="franchiseResult?.count === 0 && !loading && !forbidden"
          class="d-flex justify-content-center m-t-20"
        >
          {{ "noData" | translate }}
        </div>
        <div *ngIf="loading && !forbidden">
          <ng-container style="float: right" class="flex">
            <div class="loader-box">
              <div class="loader-34"></div>
            </div>
            <h6
              class="col align-self-center f-w-600"
              style="text-align: center"
            >
              {{ "fetching" | translate }}
            </h6>
          </ng-container>
        </div>
    </div>
    <app-pager
      [count]="franchiseResult.count"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"
      [availablePageSizes]="[5,10,15,20]"
      (emitChangePage)="changePage($event)"
      (emitChangePageSize)="itemsPerPageChange($event)"
    ></app-pager>
  </div>
</div>

<ng-template #exportFile let-modal id="exportFile">
  <div class="modal-header">
    <h4 class="modal-title" id="exportFile">
      {{ "exportFranchise.title" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      {{ "exportFranchise.body" | translate }}
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-primary"
      data-bs-dismiss="modal"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "buttons.close" | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="exportToCSV()">
      <span
        *ngIf="deletedIsLoading"
        class="spinner-border spinner-border-sm mr-1"
      ></span>
      {{ "buttons.confirm" | translate }}
    </button>
  </div>
</ng-template>
